import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import Config from './Config.js';

export default class Ronde extends Config{

	constructor(currentEnv, roomName, roomConfig, whereToAddObjects, isDiner, data) {
		super(currentEnv, roomName, roomConfig, whereToAddObjects, data);
		this.isDiner = isDiner;
		this.currentPersonneParTable = 0;

		if (data) {
			this.data = {entreTable: parseFloat(data.et), personneParTable: parseFloat(data.ppt), isEcranMural: (data.em == "true")};
		}
		else {
			this.data = {entreTable: 3, personneParTable: 8, isEcranMural: false};
		}
		this.sortieSecoursObject = this.currentEnv.getObjectByName("SortieSecours_" + this.roomName);
		this.plafonnierObject = this.currentEnv.getObjectByName("Plafonnier_" + this.roomName);

		this.roomWithDifferentPlacement = ["11"];
	}

	Show() {
		if (!this.refTableRonde) {
			this.CreateTable();
		}
		else if(!this.refPlafonnier) {
			this.CreatePlafonnier();
		}
		else if(!this.refSortieSecours) {
			this.CreateSortieSecours();
		}
		else {
			var currentTable = [];
			var currentPlafonnier = [];
			var currentSortieSecours = [];
			for (var i = 0; i < this.whereToAddObjects.children.length; i++) {
				if (this.whereToAddObjects.children[i].name == "Ronde") {
					currentTable.push(this.whereToAddObjects.children[i]);
					this.whereToAddObjects.children[i].visible = true;
					this.whereToAddObjects.children[i].simsData.id = currentTable.length;
				}

				if (this.whereToAddObjects.children[i].name == "Ecran_Plafonnier") {
					currentPlafonnier.push(this.whereToAddObjects.children[i]);
					this.whereToAddObjects.children[i].visible = false;
				}

				if (this.whereToAddObjects.children[i].name == "Sortie_Secours") {
					currentSortieSecours.push(this.whereToAddObjects.children[i]);
					this.whereToAddObjects.children[i].visible = false;
					this.whereToAddObjects.children[i].simsData = structuredClone(this.simsData);
					this.whereToAddObjects.children[i].simsData.id = currentSortieSecours.length;
				}
			}

			var distancePos = this.distanceObject.getObjectByName("Distance_" + this.roomConfig);
			if (distancePos) {
				this.CreateDistances(distancePos);
			}

			if (this.roomName != "Lully") {
				var plafonnierPos = this.plafonnierObject.getObjectByName("Plafonnier_" + this.roomConfig);
				if (plafonnierPos) {
					if (currentPlafonnier.length >= 1) {
						this.objectGenerator.ApplyTransform(currentPlafonnier[0], {refObject: plafonnierPos});
						if (this.data.isEcranMural) {
							currentPlafonnier[0].visible = true;
						}
					}
					else {
						this.objectGenerator.CloneElement(this.refPlafonnier, this.whereToAddObjects, {refObject: plafonnierPos});
					}
				}
			}

			var delim = this.delimZones.getObjectByName("DRoom_" + this.roomConfig);
			var zoneDelimData;
			if (delim) {				
				zoneDelimData = this.SetupDelimData(delim);
			}
			else {
				zoneDelimData = this.SetupDelimData(this.delimZones);
			}
			if (zoneDelimData.length) {
				zoneDelimData = zoneDelimData[0];
			}

			var sortieSecoursPos = this.sortieSecoursObject.getObjectByName("SortieSecours_" + this.roomConfig);
			if (sortieSecoursPos) {
				if (sortieSecoursPos.children.length) {
					for (var i = 0; i < sortieSecoursPos.children.length; i++) {
						if (i < currentSortieSecours.length) {
							this.objectGenerator.ApplyTransform(currentSortieSecours[i], {refObject: sortieSecoursPos.children[i]});
							currentSortieSecours[i].visible = true;
						}
						else {
							currentSortieSecours.push(this.objectGenerator.CloneElement(this.refSortieSecours, this.whereToAddObjects, {refObject: sortieSecoursPos.children[i]}));
							currentSortieSecours[currentSortieSecours.length - 1].simsData.id = currentSortieSecours.length;
						}
					}
				}
				else {
					if (currentSortieSecours.length >= 1) {
						this.objectGenerator.ApplyTransform(currentSortieSecours[0], {refObject: sortieSecoursPos});
						currentSortieSecours[0].visible = true;
					}
					else {
						currentSortieSecours.push(this.objectGenerator.CloneElement(this.refSortieSecours, this.whereToAddObjects, {refObject: sortieSecoursPos}));
						currentSortieSecours[currentSortieSecours.length - 1].simsData.id = currentSortieSecours.length;
					}
				}
			}

			zoneDelimData.minZ += 2;
			zoneDelimData.maxZ -= 2;
			zoneDelimData.minX += 2;
			zoneDelimData.maxX -= 2;

			switch(this.roomConfig) {
				case "1_2":
					zoneDelimData.minX += 0.5;
					break;
				case "1_2_3":
					zoneDelimData.minX += 0.5;
					break;
				case "11":
					zoneDelimData.minZ -= 0.5;
					zoneDelimData.maxZ += 0.5;
					zoneDelimData.minX += 0.5;
					zoneDelimData.maxX -= 0.5;
					break;
				case "Lully":
					if (this.isDiner) {
						zoneDelimData.minX += 0.5;
						zoneDelimData.maxX -= 12;
					}
					else {
						zoneDelimData.minX += 0.5;
						zoneDelimData.maxX -= 1.5;
					}
					break;
			}

			var realDistance = {};
			var newPos = {};
			realDistance.x = Math.floor((zoneDelimData.maxX - zoneDelimData.minX) / (Math.floor((zoneDelimData.maxX - zoneDelimData.minX) / this.data.entreTable)) * 10) / 10;
			realDistance.z = Math.floor((zoneDelimData.maxZ - zoneDelimData.minZ) / (Math.floor((zoneDelimData.maxZ - zoneDelimData.minZ) / this.data.entreTable)) * 10) / 10;

			var newTable;
			var tableCount = 0;
			var nbRange = 0;
			var ratioSup;
			if (this.roomWithDifferentPlacement.includes(this.roomConfig)) {
				ratioSup = realDistance.x / 2;
				for (var i = zoneDelimData.minZ; i < zoneDelimData.maxZ; i += realDistance.z) {
					for (var j = (nbRange%2 == 0)?zoneDelimData.minX:zoneDelimData.minX + ratioSup; j < zoneDelimData.maxX; j += realDistance.x) {
						newPos.posZ = i;
						newPos.posX = j;

						if (tableCount < currentTable.length) {
							this.objectGenerator.ApplyTransform(currentTable[tableCount], newPos);
						}
						else {
							currentTable.push(this.objectGenerator.CloneElement(this.refTableRonde, this.whereToAddObjects, {posX: newPos.posX, posZ: newPos.posZ, rotY: 0}));
							currentTable[currentTable.length - 1].simsData.id = currentTable.length;
							/*newTable = this.refTableRonde.clone();
							this.whereToAddObjects.add(newTable);
							newTable.rotation.set(0, 0, 0);
							this.objectGenerator.ApplyTransform(newTable, newPos);*/
						}

						tableCount++;
					}
					nbRange++;
				}
			}
			else {
				ratioSup = realDistance.z / 2;
				for (var i = zoneDelimData.minX; i < zoneDelimData.maxX; i += realDistance.x) {
					for (var j = (nbRange%2 == 0)?zoneDelimData.minZ:zoneDelimData.minZ + ratioSup; j < zoneDelimData.maxZ; j += realDistance.z) {
						newPos.posX = i;
						newPos.posZ = j;

						if (tableCount < currentTable.length) {
							this.objectGenerator.ApplyTransform(currentTable[tableCount], newPos);
						}
						else {
							currentTable.push(this.objectGenerator.CloneElement(this.refTableRonde, this.whereToAddObjects, {posX: newPos.posX, posZ: newPos.posZ, rotY: 0}));
							currentTable[currentTable.length - 1].simsData.id = currentTable.length;
							/*newTable = this.refTableRonde.clone();
							this.whereToAddObjects.add(newTable);
							newTable.rotation.set(0, 0, 0);
							this.objectGenerator.ApplyTransform(newTable, newPos);*/
						}

						tableCount++;
					}
					nbRange++;
				}
			}

			if (this.simsDataFunction) {
				this.simsDataFunction();
			}
			
			if (currentTable.length > tableCount) {
				this.HideObjectAdded(currentTable, tableCount);
			}

			if (this.data.personneParTable != this.currentPersonneParTable) {
				this.ModifyTables(currentTable);
			}

			this.data.type = "Ronde";
			this.data.tableCount = tableCount;
		}
	}

	Modify(value) {
		if (value.type == "entreTable") {
			this.data.entreTable = parseFloat(value.value);
		}
		else if (value.type == "isEcranMural") {
			this.data.isEcranMural = value.value;
		}
		else if (value.type == "personneParTable") {
			this.data.personneParTable = parseFloat(value.value);
		}
		this.Show();
	}

	ChangeRoomConfig(roomName, roomConfig, isDiner) {
		this.roomConfig = roomConfig;
		this.roomName = roomName;
		this.isDiner = isDiner;
	}

	ModifyTables(listeTables) {
		this.currentPersonneParTable = this.data.personneParTable;

		var posToApply;
		for (var i = 0; i < listeTables.length; i++) {
			var nbChaise = 0;

			for (var j = 0; j < listeTables[i].children.length; j++) {
				if (listeTables[i].children[j].name == "Chaise_Bleue") {
					if (nbChaise < this.data.personneParTable) {
						const angle = (nbChaise / this.data.personneParTable) * Math.PI * 2;
					    posToApply = {posX: 1 * Math.cos(angle), posZ: 1 * Math.sin(angle)}
				    	posToApply.rotY = Math.atan2(-posToApply.posX, -posToApply.posZ);

						this.objectGenerator.ApplyTransform(listeTables[i].children[j], posToApply)
						listeTables[i].children[j].visible = true;
					}
					else {
						listeTables[i].children[j].visible = false;
					}
					nbChaise ++;
				}
			}
		}
	}

	CreateTable() {
		this.refTableRonde = this.whereToAddObjects.getObjectByName("Ronde");
		if (this.refTableRonde) {
			this.refTableRonde.visible = false;
			this.Show();
		}
		else {
			var functionToSend = function(e){
				this.CreateTable();
			}.bind(this);
			var newPos = {functionToAdd: functionToSend};

			this.objectGenerator.AddElement("Ronde", this.whereToAddObjects, newPos, undefined , this.simsData);
		}
	}

	CreatePlafonnier() {
		this.refPlafonnier = this.whereToAddObjects.getObjectByName("Ecran_Plafonnier");
		if (this.refPlafonnier) {
			this.refPlafonnier.visible = false;
			this.Show();
		}
		else {
			var functionToSend = function(e){
				this.CreatePlafonnier();
			}.bind(this);
			var newPos = {functionToAdd: functionToSend};

			this.objectGenerator.AddElement("Ecran_Plafonnier", this.whereToAddObjects, newPos);
		}
	}

	CreateSortieSecours() {
		this.refSortieSecours = this.whereToAddObjects.getObjectByName("Sortie_Secours");
		if (this.refSortieSecours){
			this.refSortieSecours.visible = false;
			this.Show();
		}
		else {
			var functionToSend = function(e){
				this.CreateSortieSecours();
			}.bind(this);
			var newPos = {functionToAdd: functionToSend};

			this.objectGenerator.AddElement("bibliotheque/Sortie_Secours", this.whereToAddObjects, newPos, undefined , this.simsData);
		}
	}

	ResetBaseConfig() {
		this.data = {entreTable: 2.8, personneParTable: 8};
	}
}